<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 7.2C10 6.53726 9.55228 6 9 6C8.44772 6 8 6.53726 8 7.2V16.8C8 17.4627 8.44772 18 9 18C9.55228 18 10 17.4627 10 16.8V7.2ZM16 7.2C16 6.53726 15.5523 6 15 6C14.4477 6 14 6.53726 14 7.2V16.8C14 17.4627 14.4477 18 15 18C15.5523 18 16 17.4627 16 16.8V7.2Z"
    fill="currentColor"
  />
</svg>
